import React from 'react';
import { useSelector } from 'react-redux';
import ClientFormList from './ClientFormList';

const ClientForms = () => {
	const currentUser = useSelector((st) => st.user.currentUser);

	if (!currentUser) {
		return (
			<div className='min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-black flex items-center justify-center'>
				<div className='text-center'>
					<h2 className='text-2xl font-glacial font-semibold text-white mb-4'>
						Please log in to access your forms
					</h2>
					<p className='text-slate-400 font-montserrat-regular'>
						You need to be logged in to view and complete forms.
					</p>
				</div>
			</div>
		);
	}

	return <ClientFormList />;
};

export default ClientForms;